import React, { useState, useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import DialogDoublon from './DialogDoublon'
//Material UI Imports
import CreateIcon from '@material-ui/icons/Create'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useSnackbar } from 'notistack'
import MenuItem from '@material-ui/core/MenuItem'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'


//Redux
import allActions from '../../redux/actions/user'


export default function SignIn(props) {

  const classes = props.styles

  const dispatch = useDispatch()
  const { register, handleSubmit, errors, watch , setValue} = useForm()
  const { enqueueSnackbar } = useSnackbar()

  const [selectedCentre, setSelectedCentre] = useState(null)
  const [centres, setCentres] = useState([])
  const [responseError, setResponseError] = useState('')
  // const [cgu, setcgu] = useState(false)
  const [accept, setaccept] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [captchaValid, setCaptchaValid] = useState(false)
  const [errorCaptcha, setErrorCaptcha] = useState({ value: false, text: '' })


  const [dialogData, setDialogData] = useState({
    open: false,
    resolver: () => { }
  })
  const [isDialogOpenResponse, setisDialogOpenResponse] = useState(false)



  const password = useRef({})
  password.current = watch('password', '')

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await getCenter()
        if (res.err) {
          console.log('ERR: ' + res.err)
          enqueueSnackbar('Erreur: ' + res.err, { variant: `error` })
          return
        }

        setCentres(res.json)
      } catch (e) {
        console.log(e)
      }
    }
    fetchData()

  }, [])

  /**
   * Get all centers
   */
  function getCenter() {
    dispatch(allActions.setLoading(true))
    return new Promise(async (resolve) => {
      try {
        const url = 'api/center'
        const res = await fetch(process.env.REACT_APP_API_PATH + url, {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        const json = await res.json()
        resolve({ res: res, json: json })
      } catch (err) {
        resolve({ err: 'Service non disponible' })
      } finally {
        dispatch(allActions.setLoading(false))
      }
    })
  }

  /**
   * Register new user from signin form 
   */
  async function registerUser(data) {
    setResponseError('')

    if (!captchaValid) return setErrorCaptcha({ value: true, text: 'Captcha requis' })
    else setErrorCaptcha({ value: false, text: '' })

    data = { ...data, center: selectedCentre }

    const body = {
      nom: data.name,
      prenom: data.firstname,
      mail: data.email,
      password: data.password,
      cnt_id: data.center
    }

    const isExist = await allActions.fetchPostAPI('api/auth/register-check', body, dispatch)
    const { res, json } = isExist

    if (json.nb !== 0) {
      const result = await getResponseDialog();
      if (result)
        insertUser(body, data);
    }
    else {
      insertUser(body, data);
    }
  }


  function getResponseDialog() {
    return new Promise(resolve => {
      console.log(resolve)

      setDialogData({
        open: true,
        resolve
      })
    }).then((data) => {
      setDialogData({
        open: false,
        resolve: () => { }
      })
      return data
    })

  }

  async function insertUser(body, data) {
    const result = await allActions.fetchPostAPI('api/auth/register', body, dispatch)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      setResponseError('Erreur: ' + result.err)
      return
    }

    const { res, json } = result

    //Si le serveur retourne une erreur elle est affiché
    if (!res.ok) {
      setResponseError('Erreur: ' + json.message)
      return
    }

    //Affichage de l'alerte
    enqueueSnackbar(`Un mail de confirmation a été envoyé à l'adresse ${data.email}`, { variant: 'success' })
  }

  function handleCaptchaSuccess() {
    setCaptchaValid(true)
    setErrorCaptcha({ value: false, text: '' })
  }
  function handleCaptchaError(err) {
    setCaptchaValid(false)
    setErrorCaptcha({ value: false, text: err })
  }

  useEffect(() => {
    if (props.info) {
      setValue("name",props.info.nom);
      setValue("firstname",props.info.prenom);
      setValue("email",props.info.email);
    }
  }, [props.info])

  return (
    <CardContent className={classes.root} >
      <DialogDoublon dialogData={dialogData} />
      <form onSubmit={handleSubmit(registerUser)}>

        <TextField
          label="Nom"
          name="name"
          margin="dense"
          variant="outlined"
          fullWidth={true}
          required
          inputRef={register({ minLength: 2 })}
        />
        {errors.name && <FormHelperText error>Le nom doit contenir au moins 2 lettres</FormHelperText>}

        <TextField
          label="Prenom"
          name="firstname"
          margin="dense"
          variant="outlined"
          fullWidth={true}
          required
          inputRef={register({ minLength: 2 })}
        />
        {errors.firstname && <FormHelperText error>Le prénom doit contenir au moins 2 lettres</FormHelperText>}

        <TextField
          label="Email"
          name="email"
          type="text"
          margin="dense"
          variant="outlined"
          fullWidth={true}
          required
          inputRef={register({
            pattern: {
              value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: 'Adresse email invalide'
            }
          })}
          error={(errors.email !== undefined)}
        />
        {errors.email && <FormHelperText error>{errors.email.message}</FormHelperText>}

        <TextField
          label="Mot de passe"
          name="password"
          type={showPassword ? 'text' : 'password'}
          margin="dense"
          variant="outlined"
          fullWidth={true}
          // required
          inputRef={register({
            minLength: {
              value: 8,
              message: 'Le mot de passe doit contenir au moins 8 caractères'
            },
            validate: {
              hasMinChar: (value) => value.match(/.*[a-z]/) || 'Le mot de passe doit contenir au moins 1 caractère minuscule',
              hasCapsChar: (value) => value.match(/.*[A-Z]/) || 'Le mot de passe doit contenir au moins 1 caractère majuscule',
              hasDigit: (value) => value.match(/(?=.*\d)/) || 'Le mot de passe doit contenir au moins 1 chiffre',
              hasSpecialChar: (value) => value.match(/.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) || 'Le mot de passe doit contenir au moins 1 caractère speciale'
            }
          })}
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <IconButton tabIndex="-1" onClick={() => setShowPassword(!showPassword)} size="small" >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        {errors.password && <FormHelperText error>{errors.password.message}</FormHelperText>}

        <TextField
          label="Confirmer"
          name="confirm"
          type="password"
          margin="dense"
          variant="outlined"
          fullWidth={true}
          // required
          inputRef={register({
            validate: value => value === password.current || 'Les mots de passe ne correspondent pas'
          })}
        />
        {errors.confirm && <FormHelperText error>{errors.confirm.message}</FormHelperText>}


        <TextField
          select
          label="Selectionner le centre"
          margin="dense"
          variant="outlined"
          fullWidth={true}
          required={true}
          onChange={(e) => setSelectedCentre(e.target.value)}
          inputProps={{
            inputRef: (ref) => {
              if (!ref) return
              register({
                name: 'center',
              })
            },
          }}
        >
          {centres.map((c, i) => (<MenuItem value={c.id} key={i}>{c.libelle} </MenuItem>))}
        </TextField>

        {/* <FormControlLabel
      
          className={classes.switch}
          control={<Checkbox
            required
            color="primary"
            onChange={(e) => setcgu(e.target.checked)}
            checked={cgu}
            inputProps={{ ref: register, name: 'cgu' }}
          />}
          label="CGU" 
          labelPlacement="start"
        /> */}
        <p><a target="_blank" href="/documents/reglement-interieur.pdf">Règlement intérieur</a></p>
        <FormControlLabel
          className={classes.switch}
          control={<Checkbox
            required
            color="primary"
            onChange={(e) => setaccept(e.target.checked)}
            checked={accept}
            inputProps={{ ref: register, name: 'accept' }}
          />}
          label="Accepter le règlement intérieur"
          labelPlacement="start"
        />

        <HCaptcha
          sitekey={(process.env.REACT_APP_CAPTCHA_MODE === 'PROD') ? process.env.REACT_APP_KEY_CAPTCHA : process.env.REACT_APP_KEY_CAPTCHA_TEST}
          onVerify={handleCaptchaSuccess}
          onError={handleCaptchaError}
        />
        <FormHelperText style={{ color: 'red' }}>{errorCaptcha.text}</FormHelperText>

        <Button
          className={classes.button}
          fullWidth startIcon={<CreateIcon />}
          color="primary"
          variant="contained"
          type="submit"
          disableElevation
        >S'inscrire</Button>

        {responseError !== '' && <FormHelperText error>{responseError}</FormHelperText>}

      </form>
    </CardContent>
  )
}
